export default __webpack_public_path__ + "static/media/Marketing_strategy_SVG.1bf86d91.svg";